var _path;
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
import * as React from "react";
var SvgCalendar = function SvgCalendar(props) {
  return /*#__PURE__*/React.createElement("svg", _extends({
    xmlns: "http://www.w3.org/2000/svg",
    fill: "#fff",
    viewBox: "0 0 256 256"
  }, props), _path || (_path = /*#__PURE__*/React.createElement("path", {
    d: "M90.8 115.6H66v24.8h24.8zm49.6 0h-24.8v24.8h24.8zm49.6 0h-24.8v24.8H190zm24.8-86.8h-12.4V4h-24.8v24.8H78.4V4H53.6v24.8H41.2c-13.6 0-24.7 11.1-24.7 24.7v.1l-.1 173.6c0 13.6 11 24.8 24.8 24.8h173.6c13.6 0 24.8-11.2 24.8-24.8V53.6c0-13.6-11.2-24.8-24.8-24.8m0 198.4H41.2V90.8h173.6z"
  })));
};
export default SvgCalendar;